import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VrRadioGroup } from '../models/vr-radio-group';

const VRC_RADIO_GROUP_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcRadioGroupComponent),
  multi: true
};

@Component({
  selector: 'vrc-radio-group',
  templateUrl: './vrc-radio-group.component.html',
  styleUrls: ['./vrc-radio-group.component.scss'],
  providers: [VRC_RADIO_GROUP_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcRadioGroupComponent extends VrRadioGroup implements AfterViewChecked {
  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  change(value: any): void {
    this.value = value;
    this.onTouched(value);
  }
}
